export default function SliderPopup({ wrapper, onClose, closeOnOutsideClick = true }) {
  const sliderPopupContainer = '.js-scout-slider-popup__container';
  const closeIconSelector = '.js-scout-slider-popup__close';
  const overlaySelector = '.js-scout-slider-popup__overlay';
  let dialog;
  let overlay;
  let savedScrollPosition = 0;

  function getDialog() {
    if (!dialog) dialog = document.querySelector(`${wrapper} dialog`);
    return dialog;
  }

  function getOverlay() {
    if (!overlay) overlay = document.querySelector(`${wrapper} ${overlaySelector}`);
    return overlay;
  }

  function hideDialog(event) {
    event?.stopPropagation();
    const dialogElement = getDialog();
    if (!dialogElement.open) return;

    // Hide the dialog
    dialogElement.removeAttribute('open');
    document.querySelector(`${wrapper}`).classList.add('hid');

    // Hide the overlay if it exists
    const overlayElement = getOverlay();
    if (overlayElement) {
      overlayElement.classList.remove('active');
    }

    // Restore body scroll position
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    if (savedScrollPosition) {
      window.scrollTo(0, savedScrollPosition);
    }

    onClose?.();
  }

  function handleWrapperClick(e) {
    // Only handle outside clicks if closeOnOutsideClick is enabled
    if (!closeOnOutsideClick) return;

    // Only close if clicking on the wrapper or overlay, not on the container or its children
    const container = document.querySelector(`${wrapper} ${sliderPopupContainer}`);
    if (!container.contains(e.target) || e.target.matches(overlaySelector)) {
      hideDialog(e);
    }
  }

  function initialize() {
    // The close button should always close the popup
    document.querySelector(`${wrapper} ${closeIconSelector}`).addEventListener('click', hideDialog);
    // Handle wrapper clicks specially to allow clicks inside the popup to work
    document.querySelector(`${wrapper}`).addEventListener('click', handleWrapperClick);
    // Add explicit click event for the overlay if it exists (only if closeOnOutsideClick is enabled)
    if (closeOnOutsideClick) {
      const overlayElement = getOverlay();
      if (overlayElement) {
        overlayElement.addEventListener('click', hideDialog);
      }
    }
  }

  function openDialog() {
    // Save current scroll position and prevent scrolling with position:fixed
    savedScrollPosition = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${savedScrollPosition}px`;
    document.body.style.width = '100%';

    // Show the dialog
    const dialogElement = getDialog();
    dialogElement.setAttribute('open', '');
    document.querySelector(`${wrapper}`).classList.remove('hid');

    // Show the overlay if it exists and coordinate timing with slider animation
    const overlayElement = getOverlay();
    if (overlayElement) {
      // Use requestAnimationFrame to ensure the wrapper visibility change is applied before adding active class
      requestAnimationFrame(() => {
        overlayElement.classList.add('active');
      });
    }
  }

  return { initialize, openDialog, hideDialog };
}
